import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { RelatorioDevedores } from "./Devedores";
import { RelatorioHistoricoValorParcelas } from "./HistoricoValorParcelas";
import { RelatorioParcelasAtivas } from "./ParcelasAtivas";
import { RelatorioParcelasExcluidas } from "./ParcelasExcluidas";
import { isSuperUser } from "../../../utils/is-superuser";
import { RelatorioContratos } from "./Contratos";

const ReportComponent = {
  devedores: withRouter(RelatorioDevedores),
  historico_valor_parcelas: withRouter(RelatorioHistoricoValorParcelas),
  parcelas_ativas: withRouter(RelatorioParcelasAtivas),
  parcelas_excluidas: withRouter(RelatorioParcelasExcluidas),
  contratos: withRouter(RelatorioContratos)
};

export const ContratoRelatorios = () => {
  const key = "option";
  const search = window.location.search;

  if (!search || search.indexOf(key) === -1) {
    return <Redirect to="/dashboard" />;
  }

  const params = new URL(window.location.href);
  const option = params.searchParams.get("option");

  const ReportToRender = ReportComponent[option];

  if (!ReportToRender || !isSuperUser()) {
    return <Redirect to="/dashboard" />;
  }

  return <ReportToRender />;
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/Relatorios/index.jsx